export default class Termination {
  constructor(
    isSure,
    date,
    isFinePresented,
    isFineWillBePayed,
    externalId,
    paymentDate,
    currencyCode,
    rate) {
    this.isSure = isSure;
    this.date = date;
    this.isFinePresented = isFinePresented;
    this.isFineWillBePayed = isFineWillBePayed;
    this.externalId = externalId;
    this.paymentDate = paymentDate;
    this.currencyCode = currencyCode;
    this.rate = rate;
  }

  static createNew() {
    return new Termination(
      false,
      null,
      false,
      false,
      null,
      null,
      null,
      null
    );
  }

  static createFromForm(form) {
    return new Termination(
      form.isSure,
      form.date,
      form.isFinePresented,
      form.isFineWillBePayed,
      form.externalId,
      form.paymentDate,
      form.currencyCode,
      form.rate)
  }
}
